import React, { useEffect, useState } from "react";
import "./Review.scss";
import { Icon } from "@iconify/react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { auth, firestoredb } from "../../../config";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import ReviewReport from "./ReviewReport";
// const ourBrand = {
//   "webUrl": "www.epicgames.com",
//   "mainAnalysis": {
//     "brandInformation": {
//       "brandName": "Epic Games",
//       "competitors": [
//         {
//           "name": "Valve Corporation",
//           "domain": "steampowered.com"
//         },
//         {
//           "name": "Electronic Arts",
//           "domain": "ea.com"
//         },
//         {
//           "name": "Activision Blizzard",
//           "domain": "activisionblizzard.com"
//         },
//         {
//           "name": "Ubisoft",
//           "domain": "ubisoft.com"
//         },
//         {
//           "name": "Take-Two Interactive",
//           "domain": "take2games.com"
//         }
//       ],
//       "strengths": [
//         "Strong portfolio of popular games including Fortnite.",
//         "Ownership of Unreal Engine, a leading game development platform.",
//         "Successful Epic Games Store with exclusive game releases.",
//         "Significant industry partnerships and collaborations.",
//         "Robust funding and financial backing."
//       ],
//       "weaknesses": [
//         "Reliance on a few key titles for a large portion of revenue.",
//         "Controversies around game exclusivity deals.",
//         "Legal disputes with major tech companies like Apple.",
//         "Customer service issues reported by users.",
//         "Epic Games Store perceived as less user-friendly than competitors."
//       ],
//       "recommendation": [
//         "Diversify game portfolio to reduce reliance on Fortnite.",
//         "Improve customer service and user experience on the Epic Games Store.",
//         "Resolve ongoing legal disputes to focus on business growth.",
//         "Enhance community engagement and support for indie developers.",
//         "Invest in marketing strategies to improve brand perception."
//       ],
//       "productFeaturesAnalysis": {
//         "keyProductFeatures": [
//           "High-quality graphics and gameplay",
//           "Cross-platform compatibility",
//           "Innovative in-game events and collaborations",
//           "Regular updates and new content releases",
//           "Community-driven development"
//         ],
//         "interestingProductDifferntiators": [
//           "Unreal Engine's advanced game development capabilities",
//           "Epic Games Store's revenue share model for developers",
//           "Fortnite's integration of various media properties",
//           "Epic Online Services providing cross-play support"
//         ],
//         "citedQuotes": [
//           {
//             "quote": "Epic Games' Unreal Engine is revolutionizing the gaming industry with its high-fidelity graphics and real-time rendering capabilities.",
//             "source": "gamasutra.com"
//           },
//           {
//             "quote": "The Epic Games Store has disrupted the digital distribution market with its more favorable revenue split for game developers.",
//             "source": "pcgamer.com"
//           },
//           {
//             "quote": "Fortnite has become a cultural phenomenon, integrating music, film, and fashion into its gaming experience.",
//             "source": "forbes.com"
//           },
//           {
//             "quote": "Epic Games is at the forefront of cross-platform play, allowing gamers to play together regardless of the device.",
//             "source": "theverge.com"
//           },
//           {
//             "quote": "Epic's commitment to regular content updates keeps their games fresh and engaging for the community.",
//             "source": "polygon.com"
//           }
//         ]
//       },
//       "commercializationAnalysis": {
//         "keyCommercializationStrategies": [
//           "Exclusive game releases on the Epic Games Store",
//           "Competitive revenue share for developers",
//           "Free game offerings to attract users",
//           "Partnerships with hardware manufacturers",
//           "In-game purchases and seasonal battle passes"
//         ],
//         "interestingCommercializationDifferntiators": [
//           "Epic Mega Grants program supporting creators",
//           "Epic Games Store's Support-A-Creator program",
//           "Unreal Engine Marketplace for assets"
//         ],
//         "citedQuotes": [
//           {
//             "quote": "Epic Games Store's exclusivity deals have been a game-changer in how digital game stores compete for market share.",
//             "source": "engadget.com"
//           },
//           {
//             "quote": "The company's approach to giving away free games weekly has significantly increased its user base.",
//             "source": "techcrunch.com"
//           },
//           {
//             "quote": "Epic's Support-A-Creator program has helped forge a strong connection between game developers and content creators.",
//             "source": "influencermarketinghub.com"
//           },
//           {
//             "quote": "The Unreal Engine Marketplace has democratized access to high-quality game assets, empowering developers of all sizes.",
//             "source": "venturebeat.com"
//           },
//           {
//             "quote": "Epic Games' Mega Grants initiative has provided financial support to a wide range of projects in the gaming and creative industries.",
//             "source": "gamesindustry.biz"
//           }
//         ]
//       },
//       "customerExperienceAnalysis": {
//         "keyCxStrategies": [
//           "User-friendly interface and navigation",
//           "Community forums and support channels",
//           "Regular feedback solicitation and implementation",
//           "Personalized user experience through game recommendations",
//           "Accessibility features for players with disabilities"
//         ],
//         "interestingCxDifferntiators": [
//           "Epic Games' direct engagement with the gaming community",
//           "Implementation of user feedback in game development"
//         ],
//         "citedQuotes": [
//           {
//             "quote": "Epic Games has been praised for its active engagement with the community and responsiveness to player feedback.",
//             "source": "kotaku.com"
//           },
//           {
//             "quote": "The company's efforts to improve accessibility in gaming have not gone unnoticed, with features catering to disabled players.",
//             "source": "gameinformer.com"
//           },
//           {
//             "quote": "Epic Games Store's personalized recommendations aim to create a more tailored shopping experience for users.",
//             "source": "pcgamesn.com"
//           },
//           {
//             "quote": "The community forums are a hub for player interaction and support, fostering a strong sense of community.",
//             "source": "escapistmagazine.com"
//           },
//           {
//             "quote": "Epic's commitment to regular updates based on user feedback keeps the platform evolving to meet customer needs.",
//             "source": "gamesradar.com"
//           }
//         ]
//       },
//       "brandAttributesAnalysis": {
//         "keyBrandAttributes": [
//           "Innovation in gaming technology",
//           "Community and social engagement",
//           "Creative collaborations across industries",
//           "Support for indie developers",
//           "Competitive and esports initiatives"
//         ],
//         "interestingBrandAttributesDifferntiators": [
//           "Epic Games' pioneering role in cross-industry collaborations",
//           "Strong emphasis on community-driven content"
//         ],
//         "citedQuotes": [
//           {
//             "quote": "Epic Games has positioned itself as a leader in gaming innovation, particularly with its Unreal Engine technology.",
//             "source": "gamedeveloper.com"
//           },
//           {
//             "quote": "The brand's ability to engage with various industries has set a new standard for in-game events and collaborations.",
//             "source": "adweek.com"
//           },
//           {
//             "quote": "Epic's support for indie developers through various programs has helped diversify the gaming ecosystem.",
//             "source": "indiegamemag.com"
//           },
//           {
//             "quote": "The company's investment in competitive gaming and esports has bolstered its brand among hardcore gamers.",
//             "source": "espn.com"
//           },
//           {
//             "quote": "Epic Games' focus on community and social features has created a loyal and active user base.",
//             "source": "socialmediatoday.com"
//           }
//         ]
//       },
//       "marketingAnalysis": {
//         "keyMarketingStrategies": [
//           "Strategic use of social media and influencers",
//           "High-profile partnerships and sponsorships",
//           "Viral marketing campaigns",
//           "Data-driven marketing decisions",
//           "Community events and tournaments"
//         ],
//         "interestingMarketingStrategiesDifferntiators": [
//           "Leveraging in-game events for marketing",
//           "Innovative use of influencer partnerships"
//         ],
//         "citedQuotes": [
//           {
//             "quote": "Epic Games' use of social media and influencers has been instrumental in the viral success of games like Fortnite.",
//             "source": "influencermarketinghub.com"
//           },
//           {
//             "quote": "The company's high-profile partnerships, such as with Marvel and the NFL, have brought new audiences to gaming.",
//             "source": "adage.com"
//           },
//           {
//             "quote": "Epic's in-game events have set a new bar for viral marketing within the gaming industry.",
//             "source": "marketingdive.com"
//           },
//           {
//             "quote": "Data-driven marketing has allowed Epic Games to tailor its campaigns for maximum engagement and conversion.",
//             "source": "martechseries.com"
//           },
//           {
//             "quote": "Community events and tournaments have been a key marketing strategy to maintain high engagement levels.",
//             "source": "esportsobserver.com"
//           }
//         ]
//       },
//       "companyAnalysis": {
//         "numberOfEmployees": "1000+",
//         "estimatedRevenue": "$5 billion+",
//         "growthPercentageOfBrand": "23%",
//         "growthTrend": "UP",
//         "brandHealth": "85%",
//         "estimatedCustomer": "350 million+"
//       }
//     }
//   },
//   "reviews": {
//     "reviews": [
//       {
//         "reviewId": "65b08207927507338c9bde4e",
//         "consumerName": "Robert Everitt",
//         "reviewText": "rocket leauge is a joke u  cant get ur sh!t together and fix nothing u only care about seeling stuff the ranking system is so broke there is gc in every damn rank im done with this game and no im not that bad at the game u messed up the game with free to play and not ping ppls systems to make sure they dont cheat with alot of differnt accounts",
//         "reviewTitle": "rocket leauge is a joke u  cant get ur…"
//       },
//       {
//         "reviewId": "65b02a81dc2d38f5572e2b62",
//         "consumerName": "Captain Bob",
//         "reviewText": "Epic Game's Support Is Horrendous. They robbed my friend's Fortnite account he has spent thousands on. He got banned for cheating when he wasn't. He had recently been hacked and epic did not take this into consideration. When he went to support for help, they just copy and pasted messages. This is just disappointing. You would think they could deal with the situation with ease. However they get a bot to copy and paste messages to their community.",
//         "reviewTitle": "Epic's Support Is Horrendous."
//       },
//       {
//         "reviewId": "65afa6dc993755a8b40609f0",
//         "consumerName": "Mancake Warrior Sr.",
//         "reviewText": "17.6gb update. are we serious. the map is dookie meat and dont even get me started on the current rotation meta in competitive. Bring back arena hype and vault these bullshlt POIs. Also Nickeh30 skin when?",
//         "reviewTitle": "17.6gb update"
//       },
//       {
//         "reviewId": "65a340764605ab027e9acf60",
//         "consumerName": "Ibrahim Rizana",
//         "reviewText": "People have been saying that their customers service suck. In 2022 i contacted their customer services. I don’t remember exactly what I did but I got in with a real person not giving me automated answers. So as of that experience it’s not too bad but as of now I’m not sure.",
//         "reviewTitle": "Why is everyone having bad customer service experiences"
//       },
//       {
//         "reviewId": "65aadf197d9778e6cb3064f9",
//         "consumerName": "Tekky",
//         "reviewText": "As my account got hacked and email changed without even authorizing the email change (I traced back emails on my real email with authorization codes, the hacker must have accessed my gmail), after messaging epic games about it, it seemed like everything was gonne be fine, they sent me an email to \"reset\".\n\nAfter this followed a lengthy email exchange where I pretty much kept sending over 10 emails, with more proof.\n\nmy account was linked with google (that had my email), nintendo and more, I also proved ownership of the credit card etc...\n\nTheir answer was always \"due to security reasons we could not proove you are the owner\", without even telling me how I could prove myself.\n\n\"We have to obey rules, security reasons, blablabla\".\n\nMy account got hacked, and I can't even change the email, this is just beyond ridiculous.\n\nEdit: After a long back and forth, I saw a method online, which basically said to open a ticket, be straightforward, as for email change, and give as mucht details as possible.\n\nThey then sent an email to the creation email address and I was able to get my account back.\nThis took over one month, but we got it, just be persistent !",
//         "reviewTitle": "Terrible Customer service and account security"
//       },
//       {
//         "reviewId": "65ad170405c5081467c98656",
//         "consumerName": "Henry Littlemore",
//         "reviewText": "Raked is so rigged I got a 4 kill game came 4th and fanned 2 percent then I go into another game and lose 5 percent u need to fix u game asap before everyone stops playing it",
//         "reviewTitle": "Raked is so rigged I got a 4 kill game…"
//       },
//       {
//         "reviewId": "65a8d17121ab5d354f133b6d",
//         "consumerName": "Phoebe McGoo",
//         "reviewText": "Terrible customer service.  Takes 24 hours to receive a response and most of the time, they haven't read/ understood your issue so it's a waste of time.  Then they ban you from sending follow up requests when the close the original one as \"resolved\" (when nothing was resolved!!)",
//         "reviewTitle": "Terrible customer service"
//       },
//       {
//         "reviewId": "65a8e77930c6907fd3053968",
//         "consumerName": "Midnightrambler",
//         "reviewText": "Customer Service.\nI raised an issue with customer service about age restrictions on my account, the issue still hasn't been resolved and customer service just keep going round and round giving the same suggestions that don't work, despite multiple \"chats\". For such a large company with vast amounts of resources the support is pathetic. Probably the worst online support I have ever encountered. I hope they take notice of reviews, but they probably don't looking at what has been reported on trust pilot.",
//         "reviewTitle": "Customer Service."
//       },
//       {
//         "reviewId": "65a6ca419b573f1c87ea3b9c",
//         "consumerName": "Jeff Scroggs",
//         "reviewText": "Epic Games has major technical issues, but they give you lots of free Indy games. The free games are the reason for the 2-star review. Their customer and technical support is non-responsive. Reported an issue with my games getting stuck anytime there is an update. The updates are stuck as \"Queued\" and the games are unplayable and there is no way to get them to begin downloading. Submitted my support ticket November 24, 2023 and we are nearly 2 months and I still have no response to the ticket. As an IT professional myself, I've supplied full documentation of the issue to them and have received no response. I love some of the games I've purchased through them, but Epic Games is making them nearly unplayable with its technical difficulties. As a regular supporter of some of these games, I'm not spending any more money through Epic Games.",
//         "reviewTitle": "Major issues with games unable to be played"
//       },
//       {
//         "reviewId": "65afa9d2c1e7837cace18658",
//         "consumerName": "Barrfind",
//         "reviewText": "This is the worst place you can buy games. Not mention that their are phony at best. I don't trust them at all. Still that's not the points. Problem is with their launcher, app you use to download games and launch them. The worst crap I ever seen. It doesn't show you info about game, how much place you need, what it needs, anything. It lags so bad, crash and doesn't want to work at all. Look on Steam, everything works, you have everything there so who need this pile of steamy shiet that is Epic Games Launcher?",
//         "reviewTitle": "The worst"
//       },
//       {
//         "reviewId": "65a50b46f13978179c14052d",
//         "consumerName": "David",
//         "reviewText": "TERRIBLE customer support. Not even giving them every single piece of proof (even your old credit card info where all the purchases are attached) about a stolen account being yours makes them realize it's yours and WILL allow hackers to keep stolen accounts by not checking any proof. Now, they will gladly ban you by IP yet they cannot check the IP when it comes to thievery. If I were you, I would just limit myself to Steam.",
//         "reviewTitle": "TERRIBLE customer support"
//       },
//       {
//         "reviewId": "65aec97ff89b5c15072ea133",
//         "consumerName": "Lucy M",
//         "reviewText": "Chat support takes ages to reply, then days to weeks to resolve as they don’t understand what you’re describing as the problem and you can’t understand their replies…… Awful customer service",
//         "reviewTitle": "Don’t expect a swift resolution"
//       },
//       {
//         "reviewId": "65a582e5a5bc87b7396bbdca",
//         "consumerName": "customer",
//         "reviewText": "Added v bucks via a voucher on Christmas day. The v bucks never showed in my son's account. I have left multiple messages in their hard to find and then use 'contact us' section. No one has replied to any of the messages yet. I also left other contact details for myself and nothing. No v bucks credit. No customer service, nothing, a total scam.",
//         "reviewTitle": "Non existent customer service"
//       },
//       {
//         "reviewId": "65a19669133bd9a0a0710a04",
//         "consumerName": "Tor Inge",
//         "reviewText": "Horrible customer service. You get some automated crap, that doesnt help at all, then they close your ticket claiming lack of end user response!!! I request the ticket to be reopened as I havent gotten any human-based feedback, but I all get is dead silence! Horrible experience.",
//         "reviewTitle": "Horrible customer service"
//       },
//       {
//         "reviewId": "65a40744b371d01da03de81b",
//         "consumerName": "SEAN",
//         "reviewText": "Its not surprising that you already have an extremely poor 1 star rating with 82% of your reviews rated 1 star, due to your inept policies. Very poor business model you have. Pretty sure that you won't last long in this business...so many poor reviews for your customer service and so many people suffering with the same issues I am having. You claim your system is super secure yet thousands of people are losing access to their accounts. Someone needs to have a policy rethink...you have been no help to me at all.",
//         "reviewTitle": "Its not surprising that you already…"
//       },
//       {
//         "reviewId": "65a62da0498f3d875aff881f",
//         "consumerName": "Mantas Venckus",
//         "reviewText": "Selling not updated games without telling customers about it. Just bought the game played story and after that tried to play online but find out that game is old version without COOP. Checked epic store and there is no info about it at all. so basically you buying and you dont know what you will get.. Support horrible not even tried to get me refund. so i had to raise charge back... Never going to buy anything from this place.",
//         "reviewTitle": "Selling not updated games without…"
//       },
//       {
//         "reviewId": "65a538d318dcfb33eca528b5",
//         "consumerName": "Francesca",
//         "reviewText": "What an utter shambles of a company... DO NOT BUY THEIR CARDS!!! Their codes are unreadable & they leave children waiting with no replies to their emails asking for help as my son cant redeem his Christmas Vbucks. i wont be buying one again. 3 weeks & still counting & still no reply... my son is SO upset!",
//         "reviewTitle": "What an utter shambles of a company.."
//       },
//       {
//         "reviewId": "65a315f5b896cd1479daba5b",
//         "consumerName": "Samuel Eaton",
//         "reviewText": "If I could give them no stars I would after years of playing Fortnite with lots of money spent and hours played. I got logged out of my account by Epic for a reason which I was never given an answer. After weeks of back and forth they claimed they needed me to email from the account email. Which I was using to email them currently. Useless company and a waste of time. Don’t even bother trying to get anywhere their stupidity is unbelievable.",
//         "reviewTitle": "If I could give them no stars I would…"
//       },
//       {
//         "reviewId": "659c72ab01f4dfec8f3efa87",
//         "consumerName": "Mr.Xtradionary Gaming Xtradion",
//         "reviewText": "I had an account issue that occurred due to an ex girlfriend of mine changing my email only , so now I can't change my epic ID or even use 2FA or any features requiring an email for. Send a message to support sent them all the proof they asked for and boom nothing , ill be quiting fortnite / stop funding them on my end if I can't get my account secured cause I refuse to waste my time and money. Especially when there are other games out there simple as that",
//         "reviewTitle": "Was told by support they can't help me…"
//       },
//       {
//         "reviewId": "65905645e56dc2d62dc112e5",
//         "consumerName": "Andrew Wood",
//         "reviewText": "Entered wrong age when claiming a game and support said there hands are tied they can't fix it. Terrible service and awful way to treat their customers.\n\nUpdate: Still can't contact support for whatever reason but the issue is fixed.",
//         "reviewTitle": "Terrible Support!!"
//       }
//     ],
//     "totalReviews": 5034,
//     "positiveReview": 412,
//     "reviewDistribution": {
//       "1": 4099,
//       "2": 215,
//       "3": 164,
//       "4": 144,
//       "5": 412
//     }
//   }
// }

const Review = () => {
  const [showAnalysis, setShowAnalysis] = useState(false);

  const [ourBrand, setOurBrand] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  const user = auth.currentUser

  // const setOurBrand = () => {

  // }
  const handleInputChangeOurBrand = (e) => {
    setOurBrand((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleShowComparing = () => {
    setShowAnalysis(true);
  };
  function validateAndFormatURL(inputURL) {
    // Remove protocols (http, https, etc.)
    let cleanedURL = inputURL.replace(/^(https?:|ftp:)?\/\/(www\.)?/, '');

    // Add 'www.' if not present
    if (!cleanedURL.startsWith('www.')) {
      cleanedURL = 'www.' + cleanedURL;
    }

    // Ensure the URL ends with a domain (e.g., ".com")


    return cleanedURL;
  }
  const getReviews = async () => {
    try {
      setLoading(true);
      // setCompetitorBrand("")
      // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
      //     domain: ourBrand.webUrl
      // })
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "/getBrandsReviewsAnalysis",
        {
          domain: validateAndFormatURL(ourBrand.webUrl),
        }
      );
      // const response = await axios.post(
      //   process.env.REACT_APP_SERVER_URL + "/getBrandsReviewsAnalysis",
      //   {
      //     domain: ourBrand.webUrl,
      //   }
      // );
      if (response.data.message) {
        setError(true);
        setShowAnalysis(false);
        setLoading(false);

      }
      else {
        setOurBrand({ ...response.data, domainName: ourBrand.webUrl });
        setLoading(false);
        setDone(true)
      }
      // const response = await axios.post(
      //   process.env.REACT_APP_SERVER_URL + "/getBrandsReviewsAnalysis",
      //   {
      //     domain: ourBrand.webUrl,
      //   }
      // );
      // handleGptRequestCompetitor(response.data);
      // const response = await axios.post(process.env.REACT_APP_SERVER_URL + "/newgpt", {
      //     domain: url
      // })
      //   setOurBrand(response.data);
      // setLoading(false);
      // try {
      //   // setReviewsLoader(true)
      //   setLoading(true);

      //   const reviews = await axios.post(
      //     process.env.REACT_APP_SERVER_URL + "/getBrandsReviews",
      //     {
      //       domain: ourBrand.webUrl,
      //     }
      //   );
      //   if (reviews.data) {
      //     if (!reviews.data.message) {
      //       setOurBrand((prev) => ({ ...prev, reviews: reviews.data }));
      //     }
      //   }
      //   // setReviewsLoader(false)
      //   setLoading(false);
      // } catch (e) {
      //   console.log("here in catch reviews");
      //   console.log("Error", e);
      //   // setReviewsLoader(false)
      //   setLoading(false);
      // }
    } catch (e) {
      console.log("Error", e);
      setShowAnalysis(false)
      setLoading(false);
    }
  };

  const handleDbSave = async () => {
    try {
      //fetching previous data first
      if (user) {
        // // console.log("Fetching Data from DB");
        const docRef = doc(firestoredb, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // // console.log("Document data gs:", docSnap.data());
          if (docSnap.data().brandReviewsAnalysis) {

            let brandReviewsAnalysis = docSnap.data().brandReviewsAnalysis;

            await updateDoc(docRef, {
              brandReviewsAnalysis: [
                ...brandReviewsAnalysis,
                {
                  ...ourBrand, review: {}
                }
              ],
            });
            console.log("Data Successfully save to Database");
          }
          else {
            await updateDoc(docRef, {
              brandReviewsAnalysis: [
                {
                  ...ourBrand, review: {}
                }
              ],
            });
            console.log("Data Successfully save to Database");
          }
        }
      }
    }
    catch (error) {
      console.log("Error while saving to Database");
      console.log(error);
    }
  }

  useEffect(() => {
    if (done) {

      handleDbSave();
    }
  }, [done])

  useEffect(() => {
    console.log("Our Brand", ourBrand);
  }, [ourBrand]);
  return (
    <>
      {showAnalysis ? (
        // <div className="customScroller-transparent">

        //   <div className="Summary-container">
        //     <h3>Summary</h3>
        //     <div class="Summary-box">
        //       <p>{ourBrand && ourBrand.analysis ? ourBrand.analysis.summary : "Summary"}</p>
        //     </div>
        //   </div>

        //   <div className="Strenths-container">
        //     <h3>Sentiment Analysis</h3>
        //     <div className="Strenths-cards-container">
        //       <div className="strenth-card">
        //         <h3>Why Positive</h3>
        //         <ul>
        //           {ourBrand && ourBrand.analysis && ourBrand.analysis.whyPositiveReviews
        //             ? ourBrand.analysis.whyPositiveReviews
        //               .map(
        //                 (positiveReview) => (
        //                   <>
        //                     <h5>{positiveReview.heading}</h5>
        //                     <li>
        //                       <Icon
        //                         icon="solar:map-arrow-right-bold-duotone"
        //                         width="20"
        //                         height="20"
        //                       />
        //                       {positiveReview.reasons}
        //                     </li>
        //                   </>
        //                 )
        //               )
        //             : (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //             )}
        //           {/* <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Innovative problem-solving approach.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Adaptable to diverse tasks.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Detail-oriented and accurate.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Effective team player.
        //           </li>

        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Endures challenges with fortitude.
        //           </li> */}
        //         </ul>
        //       </div>

        //       <div className="strenth-card">
        //         <h3>Why Neutral</h3>
        //         <ul>
        //           {ourBrand && ourBrand.analysis && ourBrand.analysis.whyNeutralReviews

        //             ? ourBrand.analysis.whyNeutralReviews

        //               .map(
        //                 (neutralReview) => (
        //                   <>
        //                     <h5>{neutralReview.heading}</h5>
        //                     <li>
        //                       <Icon
        //                         icon="solar:map-arrow-right-bold-duotone"
        //                         width="20"
        //                         height="20"
        //                       />
        //                       {neutralReview.reasons}
        //                     </li>
        //                   </>
        //                 )
        //               )
        //             : (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //             )}
        //           {/* <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Innovative problem-solving approach.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Adaptable to diverse tasks.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Detail-oriented and accurate.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Effective team player.
        //           </li>

        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Endures challenges with fortitude.
        //           </li> */}
        //         </ul>
        //       </div>
        //       <div className="strenth-card">
        //         <h3>Why Negative</h3>
        //         <ul>
        //           {ourBrand && ourBrand.analysis && ourBrand.analysis.whyNegativeReviews

        //             ? ourBrand.analysis.whyNegativeReviews

        //               .map(
        //                 (negativeReview) => (
        //                   <>
        //                     <h5>{negativeReview.heading}</h5>
        //                     <li>
        //                       <Icon
        //                         icon="solar:map-arrow-right-bold-duotone"
        //                         width="20"
        //                         height="20"
        //                       />
        //                       {negativeReview.reasons}
        //                     </li>
        //                   </>
        //                 )
        //               )
        //             : (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //             )}
        //           {/* <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Innovative problem-solving approach.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Adaptable to diverse tasks.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Detail-oriented and accurate.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Effective team player.
        //           </li>

        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Endures challenges with fortitude.
        //           </li> */}
        //         </ul>
        //       </div>
        //     </div>
        //   </div>

        //   <div className="Strenths-container">
        //     <div className="Strenths-cards-container">
        //       <div className="strenth-card">
        //         <h3>Strengths</h3>
        //         <ul>
        //           {ourBrand && ourBrand.analysis && ourBrand.analysis.strengths ? ourBrand.analysis.strengths.map(
        //             (strengths) => (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 {strengths}
        //               </li>
        //             )
        //           )
        //             : (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //             )}
        //           {/* <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Innovative problem-solving approach.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Adaptable to diverse tasks.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Detail-oriented and accurate.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Effective team player.
        //           </li>

        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Endures challenges with fortitude.
        //           </li> */}
        //         </ul>
        //       </div>

        //       <div className="strenth-card">
        //         <h3>Weaknesses</h3>
        //         <ul>
        //           {ourBrand && ourBrand.analysis && ourBrand.analysis.weaknesses ? ourBrand.analysis.weaknesses.map(
        //             (weakness) => (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 {weakness}
        //               </li>
        //             )

        //           ) : (
        //             <li>
        //               <Icon
        //                 icon="solar:map-arrow-right-bold-duotone"
        //                 width="20"
        //                 height="20"
        //               />
        //               Delays completion of tasks.
        //             </li>
        //           )}
        //           {/* <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Delays completion of tasks.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Difficulty waiting for results.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Struggles with accepting imperfections.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Reluctant to assign responsibilities.
        //           </li>

        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Nervousness in presenting publicly.
        //           </li> */}
        //         </ul>
        //       </div>

        //       <div className="strenth-card">
        //         <h3>Recommendations</h3>
        //         <ul>
        //           {ourBrand && ourBrand.analysis && ourBrand.analysis.recommendations ? ourBrand.analysis.recommendations.map(
        //             (recommendation) => (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 {recommendation}
        //               </li>
        //             )
        //           )
        //             : (
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Embrace ongoing education opportunities.
        //               </li>
        //             )}
        //           {/* <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Embrace ongoing education opportunities.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Enhance interpersonal and written skills.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Prioritize tasks for efficiency.
        //           </li>
        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Cultivate professional relationships strategically.
        //           </li>

        //           <li>
        //             <Icon
        //               icon="solar:map-arrow-right-bold-duotone"
        //               width="20"
        //               height="20"
        //             />
        //             Establish clear, achievable objectives.
        //           </li> */}
        //         </ul>
        //       </div>
        //     </div>
        //   </div>

        //   <div className="Review-container ">
        //     <h3>Reviews</h3>
        //     <div
        //       className="Review-cards-container"
        //       style={{ overflowX: "auto" }}
        //     >
        //       {ourBrand.review &&
        //         ourBrand.review.reviews &&
        //         ourBrand.review.reviews.map((reviews, i) => (
        //           reviews.reviewText ?
        //             <div className="Review-cards-box">
        //               <h5>{reviews.consumerName}</h5>
        //               <h6>{reviews.reviewTitle}</h6>
        //               <div className="flexQuotes">
        //                 {/* <Icon
        //                 icon="ci:double-quotes-l"
        //                 className="qoutes-symbol1"
        //               /> */}
        //                 <p>{reviews.reviewText}</p>
        //                 {/* <Icon
        //                 icon="ci:double-quotes-r"
        //                 className="qoutes-symbol2"
        //               /> */}
        //               </div>
        //             </div>
        //             :
        //             ""
        //         ))}
        //       {/* <div className="Review-cards-box">
        //         <h5>La Lisa</h5>
        //         <h6>TERRIBLE customer support</h6>
        //         <div className="flexQuotes">
        //           <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
        //           <p>
        //             TERRIBLE customer support. Not even giving them every single
        //             piece of proof (even your old credit card info where all the
        //             purchases are attached) about a stolen account being yours makes
        //             them realize it's yours and WILL allow hackers to keep stolen
        //             accounts by not checking any proof. Now, they will gladly ban
        //             you by IP yet they cannot check the IP when it comes to
        //             thievery. If I were you, I would just limit myself to Steam.
        //           </p>
        //           <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
        //         </div>
        //       </div>
        //       <div className="Review-cards-box">
        //         <h5>Devil Jennie</h5>
        //         <h6>TERRIBLE customer support</h6>
        //         <div className="flexQuotes">
        //           <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
        //           <p>
        //             TERRIBLE customer support. Not even giving them every single
        //             piece of proof (even your old credit card info where all the
        //             purchases are attached) about a stolen account being yours makes
        //             them realize it's yours and WILL allow hackers to keep stolen
        //             accounts by not checking any proof. Now, they will gladly ban
        //             you by IP yet they cannot check the IP when it comes to
        //             thievery. If I were you, I would just limit myself to Steam.
        //           </p>
        //           <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
        //         </div>
        //       </div>
        //       <div className="Review-cards-box">
        //         <h5>Devil Jennie</h5>
        //         <h6>TERRIBLE customer support</h6>
        //         <div className="flexQuotes">
        //           <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
        //           <p>
        //             TERRIBLE customer support. Not even giving them every single
        //             piece of proof (even your old credit card info where all the
        //             purchases are attached) about a stolen account being yours makes
        //             them realize it's yours and WILL allow hackers to keep stolen
        //             accounts by not checking any proof. Now, they will gladly ban
        //             you by IP yet they cannot check the IP when it comes to
        //             thievery. If I were you, I would just limit myself to Steam.
        //           </p>
        //           <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
        //         </div>
        //       </div> */}
        //     </div>
        //   </div>

        // </div>
        <ReviewReport ourBrand={ourBrand}></ReviewReport>
      ) : (
        <div
          className="BrandComparison-container customScroller-transparent"
          style={{ width: "100%" }}
        >
          <h3>Get Brand reviews</h3>
          <div className="BrandComparison-socialMediaStats-container gridTemplateOnlyOne">
            <div className="BrandComparison-socialMediaStats-box">
              <h5>Analyze Brand</h5>
              <div className="brand_inputs-box">
                <h6>Brand Url</h6>
                <input
                  className="input-theme"
                  type="text"
                  placeholder="Brand Url"
                  name="webUrl"
                  onChange={handleInputChangeOurBrand}
                />
              </div>

              <button
                className="dark-theme-btn"
                onClick={() => {
                  getReviews();
                  handleShowComparing();
                }}
              >
                Start Analyzing
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal show={loading} centered>
        <Modal.Header>
          <Modal.Title>Loading... Please wait</Modal.Title>
          <button onClick={() => setLoading(false)}></button>
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="lds-ringDashboard">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={error} centered onHide={() => setError(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Opss... No Reviews Found</Modal.Title>
          {/* <button onClick={() => setLoading(false)}></button> */}
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30%",
            }}
          >
            <p className="modal-p">No enough online presence found!</p>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Review;
